import { render, staticRenderFns } from "./routerView.vue?vue&type=template&id=40e8f47e&"
import script from "./routerView.vue?vue&type=script&lang=js&"
export * from "./routerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports